import { useCallback, useMemo } from 'react';
import { Linking, Platform } from 'react-native';
import WebView from 'react-native-webview';
import { useSafeAreaInsets, useStyle } from '@bonanza-social/moonlight';
import { Config } from '@bonanza-social/toolkit/config';
import { Screen, SplashScreen } from '@bonanza-social/navigation';
import { MiscScreenProps } from './MiscScreen.types';
import { logError } from '@bonanza-social/toolkit/logging';
import { ShouldStartLoadRequest } from 'react-native-webview/lib/WebViewTypes';

function MiscScreen({ path, route }: MiscScreenProps) {
  const pathname = path ?? route?.params?.path ?? '/';
  const { bottom } = useSafeAreaInsets();
  const style = useStyle<Record<string, string | number>>({
    flex: 1,
    backgroundColor: 'screenBackground',
  });

  const url = useMemo(() => {
    return `${Config.PLATFORM_URL}${pathname}${pathname.indexOf('?') !== -1 ? '&' : '?'}isMobileApp=true`;
  }, [pathname]);

  const onError = useCallback((event: unknown) => {
    logError('MiscRouteWebviewError', event);
  }, []);

  const onShouldStartLoadWithRequest = useCallback(
    (request: ShouldStartLoadRequest) => {
      if (
        request.mainDocumentURL &&
        !request.mainDocumentURL?.match(`^${Config.PLATFORM_URL}`)
      ) {
        void Linking.openURL(request.url);

        return false;
      }

      return true;
    },
    [],
  );

  return (
    <Screen paddingHorizontal="space-0" paddingLeft="safe-area-inset-left">
      <WebView
        scrollEnabled
        decelerationRate={Platform.select({
          ios: 'normal',
          android: undefined,
        })}
        nestedScrollEnabled
        allowsBackForwardNavigationGestures
        javaScriptEnabled
        domStorageEnabled={true}
        allowFileAccess={false}
        source={{ uri: url }}
        cacheEnabled={!__DEV__}
        webviewDebuggingEnabled={__DEV__}
        onError={onError}
        onShouldStartLoadWithRequest={onShouldStartLoadWithRequest}
        originWhitelist={['*']}
        startInLoadingState
        injectedJavaScript={`
          document.documentElement.style.setProperty(
            "--safe-area-inset-bottom",
            "${bottom}px"
          );
        `}
        style={style}
        renderLoading={() => <SplashScreen />}
      />
    </Screen>
  );
}

export default MiscScreen;
